<template>
    <div class="container">
        <div class="row">
            <div v-if="categories.length" class="col-md-12">
                <ul class="offer-categories">
                    <li v-for="cat,k in categories" :key="k"><a @click.prevent="selectedCategory = cat" :class="selectedCategory == cat ? 'selected' : ''">{{ cat }}</a></li>
                    <li><a @click.prevent="selectedCategory = null" :class="selectedCategory == null ? 'selected' : ''">All offers</a></li>
                </ul>
            </div>
            <div v-for="offer in filteredOffers" class="col-md-6">
                <div class="card mb-3"
                    data-aos="zoom-in"
                    data-aos-offset="-200"
                    data-aos-delay="10"
                    data-aos-duration="500"
                    data-aos-easing="ease-in-out"
                    data-aos-mirror="true"
                    data-aos-once="false"
                    data-aos-anchor-placement="top-center"
                >
                    <div :style="'background-image:url(/storage/' + offer.img + ');'" class="card-image">&nbsp;</div>
                    <div class="card-body">
                        <h3 class="card-title">{{ offer.title }}</h3>
                        <p>{{ offer.tag_line }}</p>
                        <div>
                            {{ offer.archive_intro }}
                        </div>
                        <a :href="'/'+ offer.slug" class="btn btn-primary mt-3">Find out more</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            offers: Array,
        },

        data() {
            return {
                selectedCategory: null
            }
        },

        mounted() {
            
        },

        computed: {
            categories() {
                var cats = _.groupBy(this.offers, 'category_name')
                var catList = []
                
                _.each(cats, function(cat,k) {
                    if(k != 'null') {
                        catList.push(k)
                    }
                })
                
                return catList
            },
            filteredOffers() {
                if(this.selectedCategory) {
                    return _.filter(this.offers, ['category_name', this.selectedCategory])
                } else {
                    return this.offers
                }
            }
        },

        methods: {

        }
    }
</script>
